export class YandexSmartCaptcha {
    /*
    пример контейнера для капчи
    есть виджет maximaster:widget.yandex.smart.captcha.container
    <div
        id="aut_reg_smart_captcha"
        style="min-width: auto; margin-top: 20px"
        data-sitekey="ysc1_7Gfc5vSRT9kf7nBgpNatfxUWcZciH0nCpf9gTEidb2202d43"
        data-widget-id=""
    ></div>
    */

    /**
     * @param elementId - ID контейнера (id="aut_reg_smart_captcha")
     */
    constructor(elementId) {
        this.smartCaptcha = window.smartCaptcha || undefined;
        this.container = $('#' + elementId);

        console.log(elementId);
    }

    init() {
        if (!this.smartCaptcha) {
            throw new Error('YandexSmartCaptcha error init');
        }

        let widgetId = this.getWidgetId();
        if (!widgetId) {
            console.log('YandexSmartCaptcha: new init');

            if (this.container.length > 0 && this.container[0]) {
                widgetId = this.smartCaptcha.render(this.container[0], {
                    sitekey: this.getSiteKey()
                });
            } else {
                console.error('Контейнер капчи не найден:', this.container);
            }
            /*let widgetId = this.smartCaptcha.render(this.container[0], {
                sitekey: this.getSiteKey()
            });*/

            this.setWidgetId(widgetId);
        } else {
            console.log('YandexSmartCaptcha: reset init');
            window.smartCaptcha.reset(widgetId);
        }
    }

    getWidgetId() {
        return this.container.attr('data-widget-id');
    }

    setWidgetId(widgetId) {
        return this.container.attr('data-widget-id', widgetId);
    }

    getSiteKey() {
        return this.container.attr('data-sitekey');
    }

    hide() {
        this.container.hide();
    }

    show() {
        this.container.show();
    }

    getToken() {
        return this.container.find('[name="smart-token"]').val();
    }
}



// WEBPACK FOOTER //
// ./modules/YandexSmartCaptcha/yandex-smart-captcha.js